import { DnMedia, DnMediaSource } from '../_model/dn-media';
import { Injectable } from "@angular/core";

@Injectable()
export class MediaTransFormer {
    transform(item, mediaList = null, title = null, language = null): DnMedia {
        //console.log(item);
        const id = item.id;
        let medias = [];
        let currentMedia = null;
        if (mediaList == null) {

            if (!(item.guestSeriesList == null
                || item.guestSeriesList.length == 0)
                || !(item.vipSeriesList == null
                    || item.vipSeriesList.length == 0)) {
                medias = [...item.guestSeriesList, ...item.vipSeriesList];
                currentMedia = medias.filter(m => m.id === id);
            }

            //currentMedia = medias.filter(m => m.ID === id);
        } else {
          //  console.log(mediaList)
            medias = mediaList;
            currentMedia = medias.filter(m => m.id === id);
        }
       // console.log(currentMedia,medias,mediaList,item);
        if (currentMedia == null || currentMedia.length === 0) {
            return undefined;
        }

        const media: DnMedia = {
            id: item.id,
            pauselist: item.pauseData,
            startlist: item.startData,
            key: currentMedia[0].key || currentMedia[0].key,
            videoKey: '',
            title: (title || item.vl.title) + "-" + (currentMedia[0].title || currentMedia[0].name),
            language: language || (item.vl ? item.vl.lang : ''),
            created: currentMedia[0].created || currentMedia[0].updateDate,
            isNew: currentMedia[0].isNew || currentMedia[0].usNew,
            bought: currentMedia[0].bought || currentMedia[0].usBought,
            price: 0,
            length: 0,
            custom: item.customData,
            sources: item.flvPathList.map(s => {
                return {
                    hls: s.isHls,
                    link: s.link,
                    source: s.result,
                    type: s.type,
                    validator: s.validator,
                    broker: s.broker,
                    rtmp: s.rtmp,
                    title: s.title,
                    backup: s.backup
                };
            }),
            userBehaviors: {
                watched: 0
            },
            serverinfo: {

                status: item.videoServer.status,
                info: item.videoServer.info,
                ismp4available: item.videoServer.isMp4Available
            }
        };
        return media;
    }
}
